<router-outlet />
<app-pwa-install-banner />
<!-- <app-loading/> -->
